import { createSlice } from '@reduxjs/toolkit';
import { login } from './authThunk.js';
import { localVariables } from '../../../utils/constants.js';
import { authApi } from '../../../api/auth/authApi.js';
import { usersApi } from '@/api/index.js';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        loadingLogin: 'idle',
        accessToken: localStorage.getItem(localVariables.ACCESSTOKEN) || null,
        accessTokenExp: localStorage.getItem(localVariables.accessTokenExp) || null,
        roles: JSON.parse(localStorage.getItem(localVariables.ROLES)) || null
    },
    reducers: {
        saveAuthData: (state, data) => {
            const expiration = new Date();
            expiration.setHours(expiration.getHours() + 6);
            const expirationTimestampInSeconds = Math.floor(expiration.getTime() / 1000);
            const { accessToken, accessTokenExp, user } = data.payload;
            state.accessToken = accessToken;
            state.accessTokenExp = expirationTimestampInSeconds;
            state.roles = user?.roles;

            state.loadingLogin = 'idle';
            authApi.saveAuthData({
                ...data.payload,
                accessTokenExp: expirationTimestampInSeconds,
                roles: user?.roles
            });
        },
        clearAuthData: (state) => {
            state.accessToken = null;
            state.accessTokenExp = null;
            state.roles = null;

            state.loadingLogin = 'idle';
            authApi.clearAuthData();
            usersApi.clearProfileData()
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loadingLogin = 'loading';
            })
            .addCase(login.rejected, (state, action) => {
                state.loadingLogin = 'failed';
            })
            .addCase(login.fulfilled, (state, action) => {
                const expiration = new Date();
                expiration.setHours(expiration.getHours() + 6);
                const expirationTimestampInSeconds = Math.floor(expiration.getTime() / 1000);
                const { accessToken, accessTokenExp, user } = action.payload.data;
                state.accessToken = accessToken;
                state.accessTokenExp = expirationTimestampInSeconds;
                state.roles = user?.roles;

                state.loadingLogin = 'idle';
                authApi.saveAuthData({
                    ...action.payload.data,
                    accessTokenExp: expirationTimestampInSeconds,
                    roles: user?.roles
                });
            });
    }
});

export const { saveAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
